import React from 'react';

import {OETarget} from '../../../react-oe/oe-target';
import OEIconCodes from '../../../lib/oe-icon-codes';
import OEProtoCapBar from '../oe-proto-cap-bar';
import {OEAmbossTargetType, OEAmbossTargets, OEAmbossFeatureAccess, OEAmbossStartSelectionData} from './oe-amboss-model';

export default class OEAmbossCapBar extends React.PureComponent {

    constructor(props) {
        super(props);

        this.targetTypeMap = {
            [OEAmbossTargetType.head]:              {icon: OEIconCodes.amboss.headTarget, titleId: 'target_menu_head'},
            [OEAmbossTargetType.anatomy]:           {icon: OEIconCodes.amboss.anatomyTarget, titleId: 'target_menu_anatomy'},
            [OEAmbossTargetType.organs]:            {icon: OEIconCodes.amboss.organsTarget, titleId: 'target_menu_organs'},
            [OEAmbossTargetType.biology]:           {icon: OEIconCodes.amboss.biologyTarget, titleId: 'target_menu_biology'},
            [OETarget.effigosExplorerHelp]:         {target: OETarget.effigosExplorerHelp, icon: OEIconCodes.help, noTargetTypeBarEntry: true, titleId: 'target_menu_effigosExplorerHelp'}
        };
    }

    render()    {
        //let targetTypes = [OEAmbossTargetType.head, OEAmbossTargetType.anatomy, OEAmbossTargetType.biology, OETarget.effigosExplorerHelp];

        let targetTypes = OEAmbossStartSelectionData.chooseModules().map(module => module.id);
        targetTypes.push(OETarget.effigosExplorerHelp);

        return (
            <OEProtoCapBar
                {...this.props}
                targetTypes={targetTypes}
                targetTypeMap={this.targetTypeMap}
                versionTargets={OEAmbossTargets}
                featureAccess={OEAmbossFeatureAccess}
                startSelectionData={OEAmbossStartSelectionData}
            />
        );
    }
}